// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__31ejI","header":"ReportDetails_header__1SflO","title":"ReportDetails_title__3NVaW","left":"ReportDetails_left__3dW-H"};